import { Box, Typography } from "@mui/material";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import "./graphicAnalysis.css";
import Header from "../../../COMPONENTS/header/Header";
import Chart from "react-apexcharts";
import { data } from "../../../data/Data";

function GraphicAnalysis() {
  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="8px">
          <Header
            title="GRAPHICS ANALYSIS"
            subtitle="View more graphics analysis for the disputes in the system"
          />
          <Box display="flex" flexDirection="row" flexWrap="wrap">
            <Box flex="4" marginBottom="50px">
              <Box gridColumn="span 4" gridRow="span 2">
                <Box
                  mt="25px"
                  p="0 30px"
                  display="flex "
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="h5" fontWeight="600" color="#141414">
                      Revenue Generated
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="#4cceac">
                      $59,342.32
                    </Typography>
                  </Box>
                </Box>
                <Box height="250px" m="-20px 0 0 0">
                  <Chart
                    options={data.options}
                    series={data.series}
                    type="bar"
                    width="500"
                  />
                </Box>
              </Box>
            </Box>

            <Box flex="4" marginBottom="50px">
              <Box gridColumn="span 4" gridRow="span 2">
                <Box
                  mt="25px"
                  p="0 30px"
                  display="flex "
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="h5" fontWeight="600" color="#141414">
                      Revenue Generated
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="#4cceac">
                      $59,342.32
                    </Typography>
                  </Box>
                </Box>
                <Box height="250px" m="-20px 0 0 0">
                  <Chart
                    options={data.options}
                    series={data.series}
                    type="line"
                    width="500"
                  />
                </Box>
              </Box>
            </Box>

            <Box flex="4" marginBottom="50px">
              <Box gridColumn="span 4" gridRow="span 2">
                <Box
                  mt="25px"
                  p="0 30px"
                  display="flex "
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="h5" fontWeight="600" color="#141414">
                      Revenue Generated
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="#4cceac">
                      $59,342.32
                    </Typography>
                  </Box>
                </Box>
                <Box height="250px" m="-20px 0 0 0">
                  <Chart
                    options={data.options}
                    series={data.series}
                    type="area"
                    width="500"
                  />
                </Box>
              </Box>
            </Box>

            <Box flex="4" marginBottom="50px">
              <Box gridColumn="span 4" gridRow="span 2">
                <Box
                  mt="25px"
                  p="0 30px"
                  display="flex "
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="h5" fontWeight="600" color="#141414">
                      Revenue Generated
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="#4cceac">
                      $59,342.32
                    </Typography>
                  </Box>
                </Box>
                <Box height="250px" m="-20px 0 0 0">
                  <Chart
                    options={data.options}
                    series={data.series}
                    type="radar"
                    width="500"
                  />
                </Box>
              </Box>
            </Box>

            <Box flex="4" marginBottom="50px">
              <Box gridColumn="span 4" gridRow="span 2">
                <Box
                  mt="25px"
                  p="0 30px"
                  display="flex "
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="h5" fontWeight="600" color="#141414">
                      Revenue Generated
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="#4cceac">
                      $59,342.32
                    </Typography>
                  </Box>
                </Box>
                <Box height="250px" m="-20px 0 0 0">
                  <Chart
                    options={data.options}
                    series={data.series}
                    type="heatmap"
                    width="500"
                  />
                </Box>
              </Box>
            </Box>

            <Box flex="4" marginBottom="50px">
              <Box gridColumn="span 4" gridRow="span 2">
                <Box
                  mt="25px"
                  p="0 30px"
                  display="flex "
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="h5" fontWeight="600" color="#141414">
                      Revenue Generated
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="#4cceac">
                      $59,342.32
                    </Typography>
                  </Box>
                </Box>
                <Box height="250px" m="-20px 0 0 0">
                  <Chart
                    options={data.options}
                    series={data.series}
                    type="scatter"
                    width="500"
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default GraphicAnalysis;
